import { jwtDecode } from 'jwt-decode';
import store from '../store';
import { clearUser as clearUserSlice } from '../store/slices/userSlice';
import { clearUser } from '../redux/actions/authActions';

// Helper: check if token expired
export const isTokenExpired = (token) => {
  try {
    const { exp } = jwtDecode(token);
    return Date.now() >= exp * 1000;
  } catch (err) {
    return true;
  }
};

// Helper: clear all auth state
export const clearAuthState = () => {
  sessionStorage.removeItem('authToken');
  sessionStorage.removeItem('refreshToken');
  sessionStorage.removeItem('user');
  store.dispatch(clearUser());
  store.dispatch(clearUserSlice());
};

// Helper: validate current token and clear if expired
export const validateAndClearExpiredToken = () => {
  const token = sessionStorage.getItem('authToken');
  if (token && isTokenExpired(token)) {
    clearAuthState();
    return false;
  }
  return !!token;
};